// Any parts of a Booking can have constant defaults set up here.

export const sources = ["youtube", "twitter", "facebook", "Twitch", "Intrado"];
export const sourceLabels = [
  { source: "brandlive", label: "Brandlive" },
  { source: "bizzabo", label: "Bizzabo" },
  { source: "polyv", label: "PolyV" },
  { source: "marketpartner", label: "Market Partner" },
];
export const extendedSourceLabels = [
  { source: "facebook", label: "Facebook" },
  { source: "twitter", label: "X" },
  { source: "youtube", label: "YouTube" },
  { source: "linkedin", label: "LinkedIn" },
  { source: "snapstream", label: "SnapStream" },
  { source: "custom1", label: "Custom 1080p30 5Mbps" },
];
export const groupOptions = [1,2,3,4];

export const engagementTypeOptions = ['Live', 'Pre-Record', 'Rehearsal'];

export const initialSchedFormState = {
  eventTech: '',
  backupEventTech: '',
  engagementType: '',
  invoicingContacts: '',
  laborRequest: '',
  zoomWeb: false,
  breakouts: false,
  addSpeakerRooms: false,
  graphSupport: false,
  addStreaming: false,
  multiday: false,
  specialRequests: false,
  howsItViewed: '',
  fieldUnitSerialNums: '',
  isMultiCam: false,
  requiredUnits: '',
  liveU: false,
  numSpeakers: 0,
  group: 1,
  name: '',
  duration: '',
  preRecord: '',
  startTime: '',
  region: '',
  system: 'System_1',
  refNum: '',
  sdskNum: '',
  hours: '',
  mins: '',
  checked: true,
  date: new Date(),
};

export const regionOptions = [
  'APAC',
  'Americas',
  'EMEA'
];

export const systemOptions = [
  'System_1',
  'System_2',
  'System_3'
];

export const etList = [
  'Amos Tse',
  'Brad Crosby',
  'Christopher Morrissey',
  'Dan Lock',
  'Jen Wright',
  'Jordan Moll',
  'Joshua Roberts',
  'Julian Gomez',
  'Nazry Zakaria',
  'Ryan Meyer',
  'William White',
];
